import initialize, { interceptAxios } from '@patsnap-utils/passport';
import { psAxios } from '@patsnap/common-ps-http';
import { transformUrlProxy } from '@patsnap-utils/biz';
import get from 'lodash/get';
import {
    PASSPORT_CLIENT_ID,
    PASSPORT_CLIENT_NAME,
} from 'library-components/config/envConfig.js';

const PASSPORT_URI = process.env.VUE_APP_PASSPORT_URI;

const baseAuthServer = transformUrlProxy('passport', PASSPORT_URI);

export const passportInterceptManager = {
    inject() {
        if (!psAxios.psInterceptors.passportRequestInterceptor) {
            interceptAxios(psAxios);
        }
    },
    eject() {
        psAxios.interceptors.request.eject(psAxios.psInterceptors.passportRequestInterceptor);
        psAxios.interceptors.response.eject(psAxios.psInterceptors.passportResponseInterceptor);
        delete psAxios.psInterceptors.passportRequestInterceptor;
        delete psAxios.psInterceptors.passportResponseInterceptor;
    },
};

async function prepareTokenBase() {
    if (!psAxios.psInterceptors.passportRequestInterceptor) {
        interceptAxios(psAxios);
    }
    const initializeConfig = {
        clientName: PASSPORT_CLIENT_NAME,
        clientId: PASSPORT_CLIENT_ID,
        baseAuthServer: baseAuthServer,
        redirectToLogin(error) {
            console.log(error)
            // const redirectUrl = get(error, 'data.redirect_url');
            // if (redirectUrl) {
            //     window.location.href = redirectUrl;
            //     return;
            // }
            // const errorCode = get(error, 'errcode', '39999');
            // let logoutHref = UserCenterService.createLogoutHref(true, {
            //     errorCode,
            // });
            // if (includes(window.location.hash, 'no-permission')) {
            //     logoutHref = UserCenterService.createLogoutHref(false, {
            //         errorCode,
            //     });
            // }
            // window.location.href = logoutHref;
        },
        syncTokenParamsModifier(params) { // 可选，允许修改checksession的参数
            return {
                ...params,
                flag: 'account',
            };
        },
        onTokenRefresh() {
            console.log('onTokenRefresh');
        },
        detectResponseAsUnauthorized(err) {
            // 根据当前的请求异常来判断是否符合 token 验证失败
            return get(err, 'response.status') === 401;
        },
    };
    const passport = await initialize(initializeConfig);

    return passport;
}

export function stoper() {
    if (window.location.search.indexOf('noraven') > -1) {
        throw new Error('Local stop redirect');
    }
}

export {
    baseAuthServer,
    prepareTokenBase,
};
